import BaseUISystem from '../BaseUISystem';
import BaseMenu from './BaseMenu';
import { UIActions } from '../../../State/UI/UIActions';
import Game from '../../../Game';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import Armature from '../../../Prototype/Armature';
import { StartAnimationClip } from '../../Animation/AnimationHelper';
import { PetUnlock } from '../../Animation/Clip';
import Renderable from '../../../Component/Renderable';
import { ContextType, ResponseType } from '../../../State/Game/ContextType';
import { GameActions } from '../../../State/Game/GameActions';
import { IGameState } from '../../../State/Game/IGameState';
import UITextComponent from '../../../Component/UI/Text';
import { PetId } from '../../../Constants/Pets';
import { applyDefaultButtonAnimation } from '../UIHelper';
import { PopupID } from '../../../State/UI/PopupID';
import ElementComponent from 'Component/UI/Element';
import { isNative, Platform } from 'Utility/Platform';


export default class PetUnlockMenuHandler extends BaseMenu {
    private unlockPetArmature: Armature;
    private DBContainer: GameObject;
    private continueButtonBG: GameObject;
    private continueButton: GameObject;
    private shareButtonBG: GameObject;
    private shareButton: GameObject;
    private textBox: GameObject;

    private shareClicked: boolean;
    private petId: PetId;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.PET_UNLOCK_MENU, uiSystem);
    }

    public onCreate() {
        super.onCreate();

        this.continueButtonBG = this.element.find('continue_button_bg');
        this.continueButtonBG.getComponent(Renderable).visible = false;

        this.continueButton = this.continueButtonBG.findChildByName(
            'continue_button'
        );

        this.continueButton.on(GameObjectEvent.SELECTED, this.onContinue);
        applyDefaultButtonAnimation(this.continueButton);
        this.cleanupManager.add(() => {
            this.continueButton.off(GameObjectEvent.SELECTED, this.onContinue);
        });

        this.shareButtonBG = this.element.find('share_button_bg');
        this.shareButtonBG.getComponent(Renderable).visible = false;

        this.shareButton = this.shareButtonBG.findChildByName('share_button');

        this.cleanupManager.add(() => {
            this.shareButton.off(GameObjectEvent.SELECTED, this.onShare);
        });

        this.DBContainer = this.element.find('DB_container');

        this.unlockPetArmature = GameObject.Instantiate(Armature, {
            dragonbonesName: 'pet_unboxing',
            armatureName: 'Armature',
            animationName: 'start',
            playOnStart: false,
        });

        this.DBContainer.addChild(this.unlockPetArmature);

        this.textBox = this.element.find('text_box');
        this.configureShareButtonForNative();
    }

    public onShow(params: { petId: PetId }) {
        this.petId = params.petId;
        this.shareClicked = false; // set false to enable share

        this.textBox.getComponent(Renderable).visible = false;
        this.textBox
            .find('text')
            .getComponent(UITextComponent).text = Game.locale.getText(
            `${this.petId}SharePetUnlock`
        );

        StartAnimationClip(
            new PetUnlock(this.DBContainer, {
                armature: this.unlockPetArmature,
                continueButton: this.continueButtonBG,
                shareButton: this.shareButtonBG,
                textBox: this.textBox,
            })
        );
    }

    public handleStateChanged(state: IGameState): void {
        super.handleStateChanged(state);
        if (this.shareClicked) {
            if (
                state.context.response &&
                state.context.response.responseType ===
                    ResponseType.SHARE_PET_UNLOCKED
            ) {
                this.continueButtonBG.getComponent(Renderable).visible = true;
                this.shareButtonBG.getComponent(Renderable).visible = true;
            }
        }
    }

    public async preload() {
        Game.resource.add(
            'pet_unboxing_skeleton_data',
            'resource/dragonbones/Pets/pet_unboxing_ske.json'
        );
        Game.resource.add(
            'pet_unboxing_texture_data',
            'resource/dragonbones/Pets/pet_unboxing_tex.json'
        );
        Game.resource.add(
            'pet_unboxing_texture',
            'resource/dragonbones/Pets/pet_unboxing_tex.png'
        );

        Game.resource.add(
            'Pets',
            'resource/graphics/sprite_sheets/pets.json'
        );

        super.preload();
    }

    private readonly onShare = () => {
        this.shareClicked = true;
        this.continueButtonBG.getComponent(Renderable).visible = false;
        this.shareButtonBG.getComponent(Renderable).visible = false;
        GameActions.setContext(ContextType.SHARE_PET_UNLOCKED, {
            pet: this.petId,
        });
    };

    private readonly onContinue = () => {
        UIActions.hidePopup(PopupID.PET_UNLOCK_MENU);
    };

    private configureShareButtonForNative() {
        if(isNative()){
            this.shareButton.on(GameObjectEvent.SELECTED, this.onShare);
            return
        }

        this.continueButtonBG.getComponent(ElementComponent).anchors = [0.54, 0.9, 0.54, 0.9];
    }
}
